import {createFileRoute, Outlet, useLocation} from '@tanstack/react-router';
import {PAYMENT_ORDER_LIST} from '@/patient/routing/paths';

import PaimentOrderList from '@/patient/views/payments/PaymentOrderList';

function PaymentOrderLayout() {
  const {pathname} = useLocation();
  const isRoot = pathname === PAYMENT_ORDER_LIST;
  return isRoot ? <PaimentOrderList /> : <Outlet />;
}

export const Route = createFileRoute('/(patient)/patient/payment-orders')({
  component: PaymentOrderLayout
});
